/** User-facing labels for Auto Fill ledger rows (matrix payment 1 vs 2–3). */
export function formatAutoFillLedgerPrimary(row) {
  const amt = Number(row.amount) || 0;
  const L = row.level || 1;
  const payIdx = row.metadata?.matrixPaymentIndex;
  const type = row.transactionType;

  if (type === "POINTS") {
    return `Matrix L${L} · payment 1 of 3 · ₹${amt} → CO Points wallet`;
  }
  if (type === "LEVEL_UPGRADE" || type === "UPGRADE_RESERVE") {
    if (payIdx === 2) {
      return `Matrix L${L} · payment 2 of 3 · ₹${amt} → Upgrade pool (reserved)`;
    }
    if (payIdx === 3) {
      return `Matrix L${L} · payment 3 of 3 · ₹${amt} → Upgrade pool (with pay #2 unlocks L${L + 1})`;
    }
    return `Matrix L${L} · ₹${amt} → Upgrade pool`;
  }
  if (type === "LEVEL_ACTIVATED") {
    return `Level ${L} unlocked · ₹${amt} from upgrade pool`;
  }
  if (type === "PROGRAM_CREATED") {
    return `Program started · ₹${amt} entry`;
  }
  if (type === "ADJUSTMENT") {
    return `Balance correction · ₹${amt}`;
  }
  return `${type} · ₹${amt} · L${L}`;
}

export function formatAutoFillLedgerSecondary(row) {
  return row.reference || row.transactionId || "";
}
